import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper/core";

function Casino() {
    const navigate = useNavigate();
    
    // Khai báo các State
    const [isLoading, setLoading] = useState(false);
    const [profile, setProfile] = useState(null);
    const [playGame, setPlayGame] = useState(null); 
    const [sanh, setSanh] = useState(null);
    const [product, setProduct] = useState(null);

    // State lưu trữ dữ liệu banner
    const [notify, setNotify] = useState(() => {
        const saved = localStorage.getItem("notify");
        return saved ? JSON.parse(saved) : [];
    });

    // Hàm chạy ngầm rút tiền nếu phiên trước người dùng tắt trình duyệt ngang
    const autoRecoverMoney = (productType) => {
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: productType })
            .then((res) => {
                const currentBalance = res.data.data.balance;
                if (currentBalance > 0) {
                    return axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                        product_type: productType,
                        type: 2,
                        money: Math.floor(currentBalance)
                    });
                }
                return Promise.resolve();
            })
            .then(() => {
                localStorage.removeItem("playing_product");
                return axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`);
            })
            .then((res) => {
                if (res && res.data && res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => {
                console.log("Lỗi tự động thu hồi tiền phiên cũ:", err);
            });
    };

    // Cấu hình Axios Interceptor và khởi tạo dữ liệu ban đầu
    useEffect(() => {
        const interceptor = axios.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem("user");
                if (token) {
                    config.headers["Authorization"] = `Bearer ${token}`;
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        // Lấy thông tin User khi vào trang
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                setProfile(res.data.data);
                localStorage.setItem("profile", JSON.stringify(res.data.data));

                const interruptedProduct = localStorage.getItem("playing_product");
                if (interruptedProduct) {
                    autoRecoverMoney(interruptedProduct);
                }
            })
            .catch((err) => {
                localStorage.removeItem("user");
            });

        // Lấy dữ liệu Banner (Notify)
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {})
            .then((res) => {
                if (JSON.stringify(notify) !== JSON.stringify(res.data.data)) {
                    setNotify(res.data.data);
                    localStorage.setItem("notify", JSON.stringify(res.data.data));
                }
            }).catch(() => {});

        return () => {
            axios.interceptors.request.eject(interceptor);
        };
    }, [navigate]); // eslint-disable-line react-hooks/exhaustive-deps

    // Lắng nghe sự kiện bấm nút Quay lại (Back)
    useEffect(() => {
        const handlePopState = (event) => {
            if (playGame) {
                handleCloseGame();
            }
        };
        window.addEventListener("popstate", handlePopState);
        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [playGame, product]);

    function isMobileDevice() {
        if (window.innerWidth < 800) return true;
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    // HÀM KHỞI CHẠY GAME VÀ TỰ ĐỘNG CHUYỂN TIỀN
    function launchGame(params) {
        if (localStorage.getItem("profile") == null || localStorage.getItem("profile") === "undefined") {
            navigate("/login");
            return;
        }
        if (isLoading === true) return;

        const form = {
            ...params,
            platform: isMobileDevice() === true ? "html5" : "html5-desktop"
        };

        setLoading(true);

        let nameSanh;
        switch (params.product_type) {
            case "4": nameSanh = "AG"; break;
            case "79": nameSanh = "BBIN"; break;
            case "104": nameSanh = "CMD"; break;
            case "16": nameSanh = "CQ9"; break;
            case "27": nameSanh = "DG"; break;
            case "86": nameSanh = "Evolution"; break;
            case "142": nameSanh = "FB"; break;
            case "140": nameSanh = "JILI"; break;
            case "121": nameSanh = "KingMaker"; break;
            case "102": nameSanh = "V8 Poker"; break;
            case "123": nameSanh = "King Poker"; break;
            case "43": nameSanh = "MG"; break;
            case "39": nameSanh = "PP"; break;
            case "174": nameSanh = "SABA"; break;
            case "118": nameSanh = "WM"; break;
            case "112": nameSanh = "SEXY"; break;
            case "54": nameSanh = "SBO"; break;
            case "151": nameSanh = "UG"; break;
            case "98": nameSanh = "PG"; break;
            case "99": nameSanh = "TF"; break;
            case "3": nameSanh = "Playtech"; break;
            case "28": nameSanh = "AllBet"; break;
            case "55": nameSanh = "JDB"; break;
            case "202": nameSanh = "WS168"; break;
            case "61": nameSanh = "IMES"; break;
            case "132": nameSanh = "SV388"; break;
            default: nameSanh = ""; break;
        }
        setSanh(nameSanh);
        setProduct(params.product_type);

        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/launchgame`, form)
            .then((res) => {
                if (res.data.data.status === 0) {
                    const gameUrl = res.data.data.game_url;

                    if (profile && profile.money > 0) {
                        const amountToTransfer = Math.floor(profile.money);
                        const autoTransferData = {
                            product_type: params.product_type,
                            type: 1, 
                            money: amountToTransfer
                        };

                        axios
                            .post(`${process.env.REACT_APP_API_URL}/casino/transfer`, autoTransferData)
                            .then(() => {
                                axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`).then((userRes) => {
                                    setProfile(userRes.data.data);
                                    localStorage.setItem("profile", JSON.stringify(userRes.data.data));
                                    localStorage.setItem("playing_product", params.product_type);
                                    window.history.pushState({ inGame: true }, "");
                                    setPlayGame(gameUrl);
                                    setLoading(false);
                                });
                            })
                            .catch((err) => {
                                localStorage.setItem("playing_product", params.product_type);
                                window.history.pushState({ inGame: true }, "");
                                setPlayGame(gameUrl);
                                setLoading(false);
                            });
                    } else {
                        localStorage.setItem("playing_product", params.product_type);
                        window.history.pushState({ inGame: true }, "");
                        setPlayGame(gameUrl);
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    swal("Sảnh đang bảo trì", "Vui lòng chọn sảnh khác", "error");
                }
            })
            .catch((err) => {
                setLoading(false);
                if (err.response?.data?.data?.tokenVerificationData?.access === false) {
                    swal("Đã xảy ra lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error");
                    return;
                }
                swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra", "error");
            });
    }

    // HÀM ĐÓNG TRÒ CHƠI VÀ TỰ ĐỘNG THU HỒI
    const handleCloseGame = () => {
        setLoading(true);
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: product })
            .then((res) => {
                const currentBalance = res.data.data.balance;
                if (currentBalance > 0) {
                    const autoWithdrawData = {
                        product_type: product,
                        type: 2, 
                        money: Math.floor(currentBalance)
                    };
                    return axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, autoWithdrawData);
                }
                return Promise.resolve();
            })
            .then(() => axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`))
            .then((res) => {
                if (res && res.data && res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
                localStorage.removeItem("playing_product");
                setPlayGame(null); 
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                setPlayGame(null); 
                swal("Thông báo", "Hệ thống đang xử lý lệnh kết toán muộn. Vui lòng kiểm tra lại số dư ví tổng sau ít phút.", "warning");
            });
    };

    // Cấu hình cho Swiper banner
    const swiperParams = {
        modules: [Autoplay, Pagination],
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        pagination: { clickable: true },
    };

    return (
        <>
            <Header profile={profile} />
            
            <style>{`
                /* Đổi màu nền sang Dark Theme */
                .casino-page-wrapper {
                    background-color: #1b1e36; /* Màu nền tím đen */
                    min-height: 100vh;
                    font-family: 'Montserrat', sans-serif;
                    padding-bottom: 50px;
                }

                /* Banner Full Width */
                .main-banner-wrap {
                    width: 100%;
                    overflow: hidden;
                    margin-bottom: 30px;
                }
                .swiper-pagination-bullet { background: #fff; opacity: 0.5; }
                .swiper-pagination-bullet-active { background: #00e5ff; opacity: 1; }

                /* Container Lưới Ảnh 2 Cột */
                .casino-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 15px;
                }
                
                /* Layout dạng lưới 2 cột */
                .casino-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 25px; 
                }
                
                /* Các nút sảnh game là các bức ảnh ngang lớn */
                .casino-image-btn {
                    width: 100%;
                    height: auto;
                    cursor: pointer;
                    display: block;
                    border-radius: 6px;
                    transition: transform 0.3s ease, filter 0.3s ease;
                }
                
                /* Hiệu ứng hover nổi bật - Nhấc lên nhẹ và sáng lên (không có box-shadow) */
                .casino-image-btn:hover {
                    transform: translateY(-5px);
                    filter: brightness(1.1);
                }
                
                /* Responsive cho điện thoại */
                @media screen and (max-width: 768px) {
                    .casino-grid {
                        grid-template-columns: 1fr; /* Xuống 1 cột trên Mobile */
                        gap: 15px;
                    }
                    .main-banner-wrap {
                        margin-bottom: 15px;
                    }
                }
            `}</style>

            {isLoading === true && (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            )}

            <div className="casino-page-wrapper">
                
                {/* BANNER ĐỘNG TỪ API */}
           {notify && notify.length > 0 && (
                <div className="main-banner-wrap">
                    <Swiper {...swiperParams}>
                        {notify.map((item, index) => {
                            // CHỈ HIỂN THỊ CÁC THÔNG BÁO CÓ VỊ TRÍ LÀ 'home' (BANNER TRANG CHỦ)
                            if (item.isShow === true && item.displayLocation === "home") {
                                return (
                                    <SwiperSlide key={index}>
                                        <img 
                                            alt={item.title ? item.title.replace(/[{}]+/g, "") : "Banner"} 
                                            src={item.image} 
                                            style={{ width: "100%", maxHeight: "500px", objectFit: "cover", display: "block" }} 
                                        />
                                    </SwiperSlide>
                                )
                            }
                            return null;
                        })}
                    </Swiper>
                </div>
            )}

                {/* LƯỚI 2 CỘT CÁC SẢNH CASINO */}
                <div className="casino-container">
                    <div className="casino-grid">
                        
                        {/* Thay thế các src="..." bằng link ảnh sảnh nằm ngang của bạn */}
                        
                        {/* 1. AE SEXY */}
                        <img 
                            className="casino-image-btn" 
                            src="https://images.7087053.com/prod-images/game_icon/sv3688/bigImage/gcs__live-sex_1748852455820.avif" 
                            alt="AE SEXY" 
                            onClick={() => launchGame({ product_type: "112", game_code: "SEX001" })} 
                        />
                        
                        {/* 2. DG CASINO */}
                        <img 
                            className="casino-image-btn" 
                            src="https://images.7087053.com/prod-images/game_icon/sv3688/bigImage/gcs__live-dg_1748852553913.avif" 
                            alt="DG CASINO" 
                            onClick={() => launchGame({ product_type: "27", game_code: "DG0013" })} 
                        />
                        
                        {/* 3. WM CASINO */}
                        <img 
                            className="casino-image-btn" 
                            src="https://images.7087053.com/prod-images/game_icon/sv3688/bigImage/gcs__live-wm_1748852500210.avif" 
                            alt="WM CASINO" 
                            onClick={() => launchGame({ product_type: "118", game_code: "WM0001" })} 
                        />
                        
                     
                        {/* 5. EVOLUTION */}
                        <img 
                            className="casino-image-btn" 
                            src="https://images.7087053.com/prod-images/game_icon/sv3688/bigImage/gcs__live-eg4_1748852566966.avif" 
                            alt="EVOLUTION" 
                            onClick={() => launchGame({ product_type: "86", game_code: "EG0001" })} 
                        />

                        {/* 6. AG CASINO */}
                        <img 
                            className="casino-image-btn" 
                            src="https://images.7087053.com/prod-images/game_icon/sv3688/bigImage/gcs__live-sa_1748852486480.avif" 
                            alt="AG CASINO" 
                            onClick={() => launchGame({ product_type: "4", game_code: "A00070" })} 
                        />
 <img 
                            className="casino-image-btn" 
                            src="https://images.7087053.com/prod-images/game_icon/sv3688/bigImage/gcs__live-sa_1748852486480.avif" 
                            alt="SA CASINO" 
                            onClick={() => launchGame({ product_type: "28", game_code: "SA0001" })} 
                        />
                    </div>
                </div>
            </div>

            {/* IFRAME HIỂN THỊ GAME */}
            {playGame && (
                <div 
                    className="iframe-game-backdrop" 
                    style={{ 
                        position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", 
                        backgroundColor: "#000", zIndex: 99999, display: "flex", flexDirection: "column"
                    }}
                >
                    <div style={{
                        width: "100%", height: "50px", backgroundColor: "#162a35", 
                        display: "flex", justifyContent: "space-between", alignItems: "center",
                        padding: "0 15px", boxSizing: "border-box"
                    }}>
                        <div style={{ color: "#ffcc00", fontWeight: "bold", fontSize: "18px", fontFamily: "sans-serif" }}>
                            {sanh}
                        </div>
                        <button 
                            onClick={handleCloseGame} 
                            style={{ 
                                display: "flex", alignItems: "center", justifyContent: "center", gap: "4px",
                                backgroundColor: "#ff5050", color: "#fff", border: "none",
                                borderRadius: "20px", padding: "6px 16px", fontSize: "14px", fontWeight: "600", cursor: "pointer"
                            }}
                        >
                            <CloseIcon sx={{ fontSize: "18px" }} /> Thoát
                        </button>
                    </div>
                    <iframe 
                        src={playGame} 
                        title={`Sảnh ${sanh}`}
                        style={{ width: "100%", flexGrow: 1, border: "none" }} 
                        allowFullScreen
                    ></iframe>
                </div>
            )}
        </>
    );
}

export default Casino;